export default class UtilityHelper {
  constructor(ctx) {
    this.ctx = ctx
  }

  getSprCode()
  {
    var selectedLanguage=this.ctx.$store.getters.selectedLanguage;
    if (selectedLanguage=="de")
      return 1;
    else if (selectedLanguage=="fr")
      return 2;
    else if (selectedLanguage=="en")
      return 4;
    else
      return 1;
  }

  getSprText()
  {
    var selectedLanguage=this.ctx.$store.getters.selectedLanguage;
    if (selectedLanguage=="de")
      return "Alle";
    else if (selectedLanguage=="fr")
      return "Tous";
    else if (selectedLanguage=="en")
      return "All";
    else
      return "Alle";
  }

  initComboBoxes()
  {
    var plParameter = {
      sprcd: this.getSprCode(),
      produktReihe: "%",
      glanzgrad: "%",
      struktur: "%",
      innenAussen: "%",
      farbton: "%"
    };
    this.ctx.$store.dispatch("setPLParameter", plParameter);
  }

  rgbToHex(rgb) { 
    var hex = Number(rgb).toString(16);
    if (hex.length < 2) {
         hex = "0" + hex;
    }
    return hex;
  }

  fullColorHex(r,g,b) {
    var red = this.rgbToHex(r);
    var green = this.rgbToHex(g);
    var blue = this.rgbToHex(b);
    return red+green+blue;
  }

  getReadableForeColor(r,g,b)
  {
    return (((r+g+b)/3)>128) ? '000000' : 'ffffff';
  }

}
